import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ensureRecord } from '@/app/guards';
import { ReconRunPage, runQuery } from '@/features/collections';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/collections/reconciliation/$runId')({
  validateSearch: z.object({
    tab: z.enum(['review', 'matched', 'all']).optional().catch(undefined),
  }),
  staticData: { crumb: 'collections:nav.reconciliation', crumbTo: '/collections/reconciliation' },
  loader: async ({ context, params }) => {
    const run = await ensureRecord(context.queryClient.query({ ...runQuery(params.runId), staleTime: 'static' }));
    return { crumb: run.id };
  },
  notFoundComponent: function RecordNotFound() {
    const { runId } = Route.useParams();
    return <NotFoundView reference={runId} />;
  },
  component: function ReconRun() {
    const { runId } = Route.useParams();
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ReconRunPage
        runId={runId}
        tab={search.tab ?? 'review'}
        onTabChange={(tab) =>
          void navigate({ search: (prev) => ({ ...prev, tab }), replace: true })
        }
      />
    );
  },
});
